import {SET_PPRODUCT_DATA} from "../actions/types";

const initialState = {
    productData: {
        id: '',
        name: '',
        group_id: '',
        description: '',
        meta_description: '',
        quantity_pack: '',
        barcode: '',
        quantity: '',
        price: '',
        unit: '',
        type_id: '',
        warehouse_id: '',
        manufacturer_id: '',
        comment: '',
        site_on: '',
        code: '',
        status: '',
        user_id: '',
        suitability: '',
    }
};

const productDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PPRODUCT_DATA:
            return {...state, productData: action.payload};
        default:
            return state;
    }
};

export default productDataReducer;
